import { render, staticRenderFns } from "./passengerAgreement.vue?vue&type=template&id=beedf7ba&scoped=true&"
import script from "./passengerAgreement.vue?vue&type=script&lang=js&"
export * from "./passengerAgreement.vue?vue&type=script&lang=js&"
import style0 from "./passengerAgreement.vue?vue&type=style&index=0&id=beedf7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beedf7ba",
  null
  
)

export default component.exports